import { render, staticRenderFns } from "./SidebarLeft.vue?vue&type=template&id=44543148&scoped=true"
import script from "./SidebarLeft.vue?vue&type=script&lang=js"
export * from "./SidebarLeft.vue?vue&type=script&lang=js"
import style0 from "./SidebarLeft.vue?vue&type=style&index=0&id=44543148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44543148",
  null
  
)

export default component.exports